import { render, staticRenderFns } from "./editLockInfo.vue?vue&type=template&id=8631013c&scoped=true"
import script from "./editLockInfo.vue?vue&type=script&lang=js"
export * from "./editLockInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8631013c",
  null
  
)

export default component.exports